import { render, staticRenderFns } from "./KpiBoxes.vue?vue&type=template&id=201e4b1e&scoped=true"
import script from "./KpiBoxes.vue?vue&type=script&lang=js"
export * from "./KpiBoxes.vue?vue&type=script&lang=js"
import style0 from "./KpiBoxes.vue?vue&type=style&index=0&id=201e4b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e4b1e",
  null
  
)

export default component.exports